'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promiseClient = require('../adapters/promiseClient');

var _promiseClient2 = _interopRequireDefault(_promiseClient);

var _hubapi = require('../stacks/hubapi');

var _hubapi2 = _interopRequireDefault(_hubapi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _promiseClient2.default)(_hubapi2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.194/js/clients/apiClient.js
// module id = 185
// module chunks = 171